import React from "react"
import { CloseIcon } from "components/SvgIcons"
import { headerTitle, headerWrapper } from "../FailedRenewalModal.css"
import { colours } from "@shared/ui.design-system"

type Props = {
  handleCloseModal: () => void
}

export const Header: React.FC<Props> = ({ handleCloseModal }) => {
  return (
    <div className={headerWrapper}>
      <h1 className={headerTitle}>We couldn’t renew your membership</h1>
      <div>
        <CloseIcon
          cursor="pointer"
          color={colours.primary.dark}
          boxSize="1.5rem"
          aria-label="Close"
          onClick={handleCloseModal}
        />
      </div>
    </div>
  )
}
